import React from 'react';

export interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  placeholder?: string;
  className?: string;
}

const sizeMap = {
  small: { width: 16, height: 16, borderWidth: 2 },
  medium: { width: 32, height: 32, borderWidth: 4 },
  large: { width: 64, height: 64, borderWidth: 8 },
};

export const Spinner: React.FC<SpinnerProps> = ({ size = 'medium', placeholder, className }) => {
  const s = sizeMap[size];
  return (
    <div className={className} style={{ position: 'relative', display: 'flex', alignItems: 'center', height: '100%', width: s.width + 8 }}>
      {[0, 1, 2, 3].map((i) => (
        <div key={i} className="dyn-spinner-ring" style={{ width: s.width, height: s.height, borderWidth: s.borderWidth }} />
      ))}
      {placeholder && <span style={{ marginLeft: '0.5rem' }}>{placeholder}</span>}
    </div>
  );
};
